const ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
const LENGTH = 10
const MAX_RANDOM_BYTE = Math.floor(256 / ALPHABET.length) * ALPHABET.length

export const generatePublicId = (): string => {
  const chars: string[] = []
  const bytes = new Uint8Array(LENGTH)

  while (chars.length < LENGTH) {
    window.crypto.getRandomValues(bytes)
    for (const byte of bytes) {
      if (byte >= MAX_RANDOM_BYTE) continue

      chars.push(ALPHABET[byte % ALPHABET.length])
      if (chars.length === LENGTH) break
    }
  }

  return chars.join("")
}
